import styled from "@emotion/native"

type RadioButtonProps = {
  checked?: boolean
  handleCheck?: (newValue: boolean) => void
  fillColor?: string
}

export function RadioButton({
  checked,
  fillColor = "green",
  handleCheck = () => null,
}: RadioButtonProps) {
  return (
    <Wrapper fillColor={fillColor} onPress={() => handleCheck(!checked)}>
      <Content fillColor={checked ? fillColor : "white"} />
    </Wrapper>
  )
}

type ContentProps = {
  fillColor: string
}

const Wrapper = styled.Pressable`
  width: 24px;
  height: 24px;
  border-radius: 100px;
  align-items: center;
  justify-content: center;
  border-width: 1px;
  border: ${(props: ContentProps) => props.fillColor};
`

const Content = styled.View`
  width: 18px;
  height: 18px;
  border-radius: 100px;
  background-color: ${(props: ContentProps) => props.fillColor};
`
